export const GET_HASHTAG_FEED_REQUEST = 'GET_HASHTAG_FEED_REQUEST';
export const GET_HASHTAG_FEED_SUCCESS = 'GET_HASHTAG_FEED_SUCCESS';
export const GET_HASHTAG_FEED_FAILURE = 'GET_HASHTAG_FEED_FAILURE';

export const RESET_HASHTAG_FEED = 'RESET_HASHTAG_FEED';